import { gql } from '@apollo/client';

export default gql`
    query loadEntityImageQuery($type: String!, $id: ID!) {
        result: entity(type: $type, id: $id) {
            image
        }
    }
`;
